import * as React from "react";
import {
  createBrowserRouter,
} from "react-router-dom";

import Login from "./components/auth/login";
import Verify from "./components/auth/verifyOtp";
import SignUp from "./components/auth/signup";
import Dashboard from "./components/dashboard/dashboard";
import Chat from "./components/ticket/chat";
import FaqPage from './components/auth/login/faq'

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/verification",
    element: <Verify />,
  },
  {
    path: "/sign-up",
    element: <SignUp />,
  },
  {
    path: '/faq',
    element: <FaqPage />
  },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/user/:userId",
    element: <Dashboard />,
  },
  {
    path: "/ticket/:ticketId",
    element: <Chat />,
  },
]);

export default router
